export const MATCHING_SUBCATEGORY_WHITELIST = ['POS US', 'Vehicle Tracking US'];

export default MATCHING_SUBCATEGORY_WHITELIST;
